import React from "react";
import { Box, keyframes } from "@mui/system";

const dotPulse = keyframes`
  0% {
    opacity: 1;
    transform: scale(1);
  }
  50% {
    opacity: 0.3;
    transform: scale(0.8);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
`;

const ThreeDotLoader = () => {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "50vh",
      }}
    >
      <Box
        sx={{
          display: "flex",
          "& > div": {
            width: "8px",
            height: "8px",
            backgroundColor: "red",
            borderRadius: "50%",
            margin: "0 4px",
            animation: `${dotPulse} 0.6s infinite alternate`,
            "&:nth-of-type(1)": {
              animationDelay: "0s",
            },
            "&:nth-of-type(2)": {
              animationDelay: "0.2s",
            },
            "&:nth-of-type(3)": {
              animationDelay: "0.4s",
            },
          },
        }}
      >
        <Box />
        <Box />
        <Box />
      </Box>
    </Box>
  );
};

export default ThreeDotLoader;
